<template>
	<div>
		<div id="slide" :style="{backgroundImage:'url('+require('@/assets/images/survey_meeting.jpg')+')'}">
			<loading :active.sync="isLoading">
			</loading>

			<template v-if="completeYn == 'Y'">
				<b-container id="slider" cols="7" class="p-5">
					<b-container class="p-5 text-center">
						<h3><b>설문조사가 완료되었습니다.</b></h3>
						<h3><b>감사합니다.</b></h3>
					</b-container>
				</b-container>
			</template>

			<template v-else>
				<b-col cols="3" class="position-relative mx-auto text-center my-5" style="color:white;">
					<p><b>Survey Completion</b></p>
					<b-progress>
						<b-progress-bar :value="((current+1)/(questionList.length)) * 100" style="background-color:#ffe600;"></b-progress-bar>
					</b-progress>
					<div class="d-flex justify-content-between" style="font-size: 0.8rem">
						<div>0%</div>
						<div>100%</div>
					</div>
        		</b-col>
				<b-container id="slider" cols="7" class="p-5 mx-auto my-5">
					<b-container v-if="current == -1" class="text-center px-5">
						<div class="slide px-5 mt-5 mb-5 text-left font-weight-bold" style="font-size: 1.5rem" v-html="surveyInfo.title"></div>
						<pre style="font-size: 1rem" v-html="surveyInfo.description"></pre>
					</b-container>
					<transition name="fade" class="slides-group" v-for="(question, i) in questionList" :key="question.questionId">
						<b-container class="slide px-5 mt-5" :key="current" v-if="i == current">
							<b-container class="px-5">
								<pre style="font-size: 1.5rem; font-weight: bold;" v-if="questionList[categoryIdx]">{{ questionList[categoryIdx].questionNum ? questionList[categoryIdx].questionNum : ''}} {{ questionList[categoryIdx].questionTitle }}</pre>
								<pre style="font-size: 1.3rem; font-weight: bold;">{{ question.questionNum ? question.questionNum : ''}} {{ question.questionTitle }}</pre>
								<pre style="font-size: 1.15rem; font-weight: bold;">{{ question.questionDesc}}</pre>
								<b-form-group class="p-4" v-if="question.type == '세로형객관식'">
									<b-form-radio v-model.lazy="question.answer" :name="'vertical-radios'+i" class="p-1" 
																v-for="choice in question.choiceList" :key="choice.choiceNum" :value="choice" @change="changeRadio(i, choice)">
										{{ choice.choiceContents }}
									</b-form-radio>
								</b-form-group>
								<b-form-group class="p-4" v-if="question.type == '가로형객관식'">
									<b-form-radio-group v-model.lazy="question.answer" :name="'horizon-radios'+i">
										<b-form-radio class="p-1 mr-5" v-for="choice in question.choiceList" :key="choice.choiceNum" :value="choice" @change="changeRadio(i, choice)">
											{{ choice.choiceContents }}
										</b-form-radio>
									</b-form-radio-group>
								</b-form-group>
								<b-form-group class="p-4 col-11" v-if="question.type == '주관식'">
									<b-form-textarea id="textarea" v-model.lazy="question.answer" placeholder="내용을 입력해 주세요." rows="3" max-rows="5">
									</b-form-textarea>
								</b-form-group>
								<b-form-group>
									<b-form-checkbox-group class="p-4" v-model.lazy="question.answer" v-if="question.type == '체크리스트'" v-slot="{ ariaDescribedby }">
										<b-form-checkbox class="d-block p-1" :aria-describedby="ariaDescribedby" name="some-checkbox"
																		v-for="choice in question.choiceList" :key="choice.choiceNum" :value="choice">
											{{ choice.choiceContents }}
										</b-form-checkbox>
									</b-form-checkbox-group>
								</b-form-group>
								<b-form-group class="p-4" v-if="question.type == '없음'">
								</b-form-group>
								<b-form-group class="p-4" v-if="question.type == '동의여부'">
									<b-form-radio v-model.lazy="question.answer" :name="'some-radios'+i" class="p-1"
																v-for="choice in question.choiceList" :key="choice.choiceNum" :value="choice" @change="changeRadio(i, choice)">
										{{ choice.choiceContents }}
									</b-form-radio>
								</b-form-group>
								<b-form-group class="p-4" v-if="question.type == '복합형객관식'">
									<b-form-radio-group v-model.lazy="question.answer" :name="'complex-radios'+i">
										<b-form-radio class="d-block p-1" v-for="choice in question.choiceList" :key="choice.choiceNum" :value="choice" @change="checkDisabled(question, i)">
											{{ choice.choiceContents.includes('주관식') ? choice.choiceContents.replaceAll('(주관식)', '') : choice.choiceContents}}
											<b-form-textarea v-if="choice.choiceContents.includes('주관식')" v-model.lazy="question.answer.input" 
															:disabled="disableYn" rows="3" max-rows="5" style="width: 600px;"></b-form-textarea>
										</b-form-radio>
									</b-form-radio-group>
								</b-form-group>
							</b-container>
							<b-button v-if="current == questionList.length-1" variant="outline-warning" type="submit" style="float:right;" @click="showConfirmMsg()">Submit</b-button>
						</b-container>
					</transition>
					<div class="custom-btn btn-prev" aria-label="Previous slide" @click="slide(-1)" v-if="current >= 0">
						&#10094; 
					</div>
					<div class="custom-btn btn-next" aria-label="Next slide" @click="slide(1)" style="float:right;" v-if="current < questionList.length-1">
						&#10095;
					</div>
				</b-container>
			</template>
		</div>
		<b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
			<p class="my-4 text-center">{{ msgContent }}</p>
		</b-modal>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import store from "@/store/index";

export default ({
	props: { secret: String },
	components: { Loading },
	async beforeRouteEnter(to, from, next) {
		await axios.post("/survey/checkPeriod/" + to.params.secret)
		.then(response => {
			if (response.data.status === 1 && response.data.completeYn === 'Y') {
				next("/signin");
				store.commit("setMessage", "이미 완료된 설문입니다.");
			} else if (response.data.status === 0) {
				next("/signin");
				store.commit("setMessage", "현재는 설문조사 기간이 아닙니다. (기간: " + response.data.startDate + " ~ " + response.data.endDate + ")");
			} else if (response.data.status === -1) {
				next("/signin");
				store.commit("setMessage", "정확하지 않은 주소입니다.");
			} else {
				next()
			}
		}).catch(e => {
			next("/signin");
			store.commit("setMessage", e.message);
		});
	},
	data() {
		return {
			isLoading: false,
			msgStatus: "",
			msgContent: "",
			completeYn: 'N',
			questionList: [],
			surveyInfo: {},
			current: -1,
			startTime:'',
			endTime:'',
			disableYn: true,
			relation: true,
			categoryIdx:0,
			categoryIdxList:[]
		}
	},
	watch: {
		current: function() {
			// 이전 문항으로 돌아갈 때, 카테고리항목 이전으로..
			if(this.current >= 0 && this.current < this.categoryIdx) {
				let currIdx = this.categoryIdxList.indexOf(this.categoryIdx);
				this.categoryIdx = this.categoryIdxList[currIdx-1];
			}
		}
	},
	methods: {
		slide(dir) {
			// 필수여부 체크
			if((dir > 0 && this.current >= 0) && this.questionList[this.current].required=='Y') {
				if(this.validate()) {
					this.showMessage(0, '답변을 선택 또는 입력해 주세요.');
					return;
				}
			}
			
			this.current = this.current + dir;
			
			// 문항type: 카테고리인 경우 예외처리 
			if(this.current >= 0 && this.questionList[this.current].type == '카테고리') {
				this.categoryIdx = this.current;
				this.current = this.current + dir;
			} 
			
			if(this.current >= 0) {
				// 연관 문항 체크 : 현재 문항의 relationQuestion이 0이 아니면
				const currQuestion = this.questionList[this.current];
				if(currQuestion.relationQuestion != 0) {
					// qeustionList에서 questionId가 relationId인 요소를 찾아 그 요소의 relationChoice
					const rq = this.questionList.find((item) => item.questionId === currQuestion.relationQuestion);
					// 문항유형이 체크리스트일 경우: 사용자 응답 Array
					if(Array.isArray(rq.answer)) {
						this.relation = rq.answer.some(
							(choice) => currQuestion.relationChoice.includes(choice.choiceContents)
						);
					} else {
						currQuestion.relationChoice.includes(rq.answer);
					}
				} else {
					this.relation = true;
				}
			} else {
				this.relation = true;
			}
			if(!this.relation) this.slide(dir);
		},
		showMessage(status, message) {
			this.msgStatus = status;
			this.msgContent = message;
			this.$bvModal.show("messageModal");
		},
		showConfirmMsg() {
			if(this.questionList[this.current].required=='Y' && this.validate()) {
				this.showMessage(0, '답변을 선택 또는 입력해 주세요.');
				return;
			}

			this.$bvModal.msgBoxConfirm(this.$createElement('div', { domProps: { 
				innerHTML: '<h5 class="pt-3"><b>설문 제출 후에는 수정이 불가합니다.</b></h5><h5><b>설문을 제출 하시겠습니까?</b></h5>' } }), {
				title: ' ',
				size: 'md',
				buttonSize: 'sm',
				bodyClass:'p-3 font-weight-bold text-center',
				okVariant: 'warning',
				cancelVariant: 'outline-secondary',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'justify-content-end p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value) this.save();
				else return;
			});
		},
		validate() {
			const currQuestion = this.questionList[this.current];
			let flag = false;
			switch(currQuestion.type) {
				case '복합형객관식': currQuestion.answer.choiceContents.includes('주관식') && 
				(!currQuestion.answer.hasOwnProperty('input') || currQuestion.answer.input == '')? flag = true : flag = false; break;
				case '주관식': currQuestion.answer == '' ? flag = true : flag = false; break;
				case '카테고리': 
				case '없음': break;
				case '체크리스트': currQuestion.answer.length == 0 ? flag = true : flag = false; break;
				default: currQuestion.answer.choiceNum == null ? flag = true : flag = false; break;
			}
			if(!this.relation) flag = false;
			return flag;
		},
		checkDisabled(question) {
			// 사용자 답에 주관식이 포함되어 있지 않은 경우
			if(!question.answer.choiceContents.includes('주관식')) {
				this.disableYn = true;
				delete question.input;
			} else {
				this.disableYn = false;
			}
		},
		async loadQuestionnaire() {
			this.isLoading = true;

			await axios.get('survey/retrieveQuestionnaire/' + this.secret,
			{	headers: {
					'Accept': 'application/json',
				}
			}).then(response => {
				this.completeYn = response.data.completeYn;
				this.surveyInfo = response.data.surveyInfo;
				this.questionList = response.data.questionList;

				// answer값 초기화
				this.questionList.forEach((item, i) => {
					if(item.type == '카테고리') {
						this.categoryIdxList.push(i);
					}
					switch(item.type) {
						case '체크리스트': item.answer = []; break;
						case '복합형객관식': item.answer = { choiceNum: null, choiceContents: '', input: '' }; break;
						case '주관식': item.answer = ''; break;
						default: item.answer = { choiceNum: null, choiceContents: ''}; break;
					}
				});
				this.categoryIdx = this.questionList.findIndex(item => item.type === '카테고리');

			}).catch(e => {
				this.showMessage(e.status, e.message);
			}).finally(() => {
				this.isLoading = false;
			});
		},
		async save() {

			this.isLoading = true;
			this.endTime = this.dateFormat();

			const questionnaireInfo = {
				surveyInfo: this.surveyInfo,
				questionList: this.questionList,
				startTime: this.startTime,
				endTime: this.endTime,
				secret: this.secret
			};

			await axios.post('/survey/storeAnswer', questionnaireInfo).then(res => {
				this.completeYn = 'Y';
			}).catch(e => {
				this.showMessage(e.status, e.message);
			}).finally(() => {
				this.isLoading = false;
			});
		},
		dateFormat() {
			let date = new Date();
			let month = date.getMonth() + 1;
			let day = date.getDate();
			let hour = date.getHours();
			let minute = date.getMinutes();
			let second = date.getSeconds();

			month = month >= 10 ? month : '0' + month;
			day = day >= 10 ? day : '0' + day;
			hour = hour >= 10 ? hour : '0' + hour;
			minute = minute >= 10 ? minute : '0' + minute;
			second = second >= 10 ? second : '0' + second;

			return date.getFullYear() + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
		},
		changeRadio(i, choice) {
			// v-model이랑 value랑 binding되지 않는 경우가 있어서 추가.. 성능 문제인듯
			this.questionList[i].answer = choice;
		}
	},
  created() {
    this.loadQuestionnaire();
    this.startTime = this.dateFormat();
  }
})
</script>
<style scoped>
pre {
	white-space: pre-wrap;
	max-height: 300px;
	text-align: left;
	font-family: "Segoe UI",Arial,sans-serif;
}

#slide {
	margin: 0;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	position: relative;
	height: 100vh;
	padding-top: 50px;
}

#slide::before {
	content: "";
	opacity: 0.5;
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	background-color: #000;
}

#slider {
	background-color: white;
	position: relative;
	border-radius: 20px;
	overflow: auto;
}

.slide {
	border-radius: 20px;
}

.fade-enter-active {
	transition: opacity .5s;
}

.fade-enter {
	opacity: 0;
}

.custom-btn {
	z-index: 10;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 70px;
	position: absolute;
	top: calc(50% - 35px);
	left: 3%;
	transition: transform 0.3s ease-in-out;
	user-select: none;
	scale: 2;
}

.btn-next {
	left: auto;
	right: 3%;
}

.custom-btn:hover {
	transform: scale(1.1);
}
</style>